import Skills from "./Skills.js";
import { Link,withRouter} from "react-router-dom";
export default withRouter(Skills);
